<template>
  <div class="assessment">
    <h2>Coming soon!</h2>
  </div>
</template>

<script>
export default {
  name: 'Assessment'
};
</script>

<style scoped>
.assessment {
  padding: 40 60px;
  color: black;
  font-size: 20px;
}
</style>
